import { SCENE_SCALE } from "../../constants";

export const FRAME_SIZE = 2.1 * SCENE_SCALE;

export const FRAME_HEIGHT = FRAME_SIZE;

export const FRAME_WIDTH = FRAME_SIZE / 3 * 4;